import { request } from '@/shared/api/request'

export const getStatusProject = ({params}) => {
	return request({
		method: 'POST',
		url: 'staff/xml/status/send',
		params
	})
}
